import React from 'react';
import { Badge } from 'react-bootstrap';
export default function UserAccessBusinessUnitBadges(_ref) {
  let {
    userAccess
  } = _ref;
  if (!userAccess?.user_access_business_unit_participations?.length) {
    return /*#__PURE__*/React.createElement(React.Fragment, null);
  }
  return userAccess.user_access_business_unit_participations?.map((participation, index) => {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Badge, {
      key: index,
      bg: "primary"
    }, participation.business_unit.name), ' ');
  });
}